import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api/src/common/queryFunction';

import type {
  BulkUpdatePartFileRequestBody,
  BulkUpdatePartFileResponseBody,
} from './types';

export const useBulkUpdatePartFiles: MutationFunction<
  BulkUpdatePartFileResponseBody,
  BulkUpdatePartFileRequestBody
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  return useMutation(
    (requestBody) => {
      return request<BulkUpdatePartFileResponseBody>(
        `/parts/files/bulk_detail/`,
        {
          init: {
            method: 'PATCH',
            body: requestBody,
          },
        },
      );
    },
    {
      ...queryOptions,
      mutationKey: ['bulkUpdatePartFile'],
    },
  );
};
